var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.32132H18V19.3213H5V3.32132Z",
    fill: "#0679CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.32132C6.13329 0.32132 5 3.32132 5 3.32132H18C18 3.32132 16.8667 0.32132 11.5 0.32132Z",
    fill: "#002D62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.3213H6V25.3213H7V26.3213H5V19.3213Z",
    fill: "#1C1C1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.3213H17V25.3213H16V26.3213H18V19.3213Z",
    fill: "#1C1C1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.821348C16.0867 -0.00525993 15.4354 -0.0160364 14.5715 0.00508035C14.256 0.0127924 14 0.271179 14 0.586768C14 0.992459 14.3288 1.32134 14.7345 1.32134H16C16.5 1.82134 17.3164 2.32133 17.3164 2.32133C17.1497 2.15467 16.753 1.32732 16.5 0.821348Z",
    fill: "#53A4DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.3213C6.13329 22.3213 5 19.3213 5 19.3213H18C18 19.3213 16.8667 22.3213 11.5 22.3213Z",
    fill: "#002D62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.32132H11.5V23.1672C11.5 23.2693 11.4861 23.3719 11.4403 23.4632C11.3662 23.611 11.2219 23.8213 11 23.8213C10.7781 23.8213 10.6338 23.611 10.5597 23.4632C10.5139 23.3719 10.5 23.2693 10.5 23.1672V3.32132Z",
    fill: "#002D62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.32132H11.5V22.2878H12V3.32132Z",
    fill: "#012946"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.3213H23V26.3213H0V25.3213Z",
    fill: "#012946"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.32147H12V8.32147H10.5V7.32147Z",
    fill: "#E0EFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.00018H12V10.0002H10.5V9.00018Z",
    fill: "#E0EFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.3215H12V16.3215H10.5V15.3215Z",
    fill: "#E0EFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.0002H12V18.0002H10.5V17.0002Z",
    fill: "#E0EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfNew);
export default __webpack_public_path__ + "static/media/CF_new.b52f3ff9bd289b5c16e27db194568386.svg";
export { ForwardRef as ReactComponent };